import {
  FETCH_TEMPLATE_CONTENT_BY_QUERY_PARAMS_FULFILLED,
  GetTemplateActionResponse
} from '../actions/getTemplateContentByQueryParams';

export default (
  state: { [k: string]: any } = {status: 'INITIAL'},
  action: GetTemplateActionResponse
) => {
  switch (action.type) {
    case FETCH_TEMPLATE_CONTENT_BY_QUERY_PARAMS_FULFILLED: {
      return {
        ...state,
        [action.meta.templateName]: action.payload.data,
        status: 'FULFILLED',
      };
    }
    default:
      return state;
  }
};
